import React, { ReactElement } from 'react';
import { Link as ReactRouterLink, LinkProps } from 'react-router-dom';
import { Link as ReactMDLink } from '@react-md/link';

export const RouterLink: React.FC<LinkProps> = (props: LinkProps): ReactElement => {
    return <ReactMDLink component={ReactRouterLink} {...props} />;
};
